module.exports = __webpack_public_path__ + "img/fuse.41c294e3.png";